import { domToBlob } from "modern-screenshot";
import { mapLogoUpload } from ".";
import { showToaster } from "../redux/slices/toastSlice";
import { DisplayErrorMessages } from "../utils/helper";

export const SaveMapScreen = async (dispatch) => {
  return new Promise((resolve, reject) => {
    const mapElement = document.getElementById("map");
    if (!mapElement) {
      reject(new Error("Map element not found"));
      return;
    }
    domToBlob(mapElement, {
      scale: 0.5,
      backgroundColor: "none",
    })
      .then((blob) => {
        const imgBlob = blob;
        const formData = new FormData();
        formData.append(
          "file",
          imgBlob,
          `map-screenshot-${Math.random().toString(16).slice(2)}.png`
        );
        mapLogoUpload({
          params: "?mapScreen=true",
          body: formData,
          conifg: { headers: { "Content-Type": "multipart/form-data" } },
        })
          .then((res) => {
            if (res.data.data.logoUrl) {
              resolve(res.data.data.logoUrl);
            } else {
              resolve(null);
            }
          })
          .catch((err) => {
            console.log("err", err);
            const error = DisplayErrorMessages(err);
            resolve(null);
            dispatch(
              showToaster({
                dialogBgColor: "bg-danger",
                dialogMsg: error,
                showDialog: true,
                timer: "5000",
              })
            );
          });
      })
      .catch((error) => {
        console.log("Error capturing canvas:", error);
        resolve(null);
        dispatch(
          showToaster({
            dialogBgColor: "bg-danger",
            dialogMsg: "There is an error in capturing the image",
            showDialog: true,
            timer: "5000",
          })
        );
      });
  });
};
